import { render, staticRenderFns } from "./revise.vue?vue&type=template&id=06a066f3&scoped=true&"
import script from "./revise.vue?vue&type=script&lang=js&"
export * from "./revise.vue?vue&type=script&lang=js&"
import style0 from "./revise.vue?vue&type=style&index=0&id=06a066f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a066f3",
  null
  
)

export default component.exports